// Numbered steps on bottle box product pages (snippets/product-step.liquid).
// A step stays visible only when something under it actually renders. App blocks
// (PC Product Options, Selleasy) load after the page, so this re-checks as they appear,
// then renumbers the visible steps 1, 2, 3...
(() => {
  if (window.stagProductSteps) return;
  window.stagProductSteps = true;

  const isEndOfSteps = (el) =>
    el.matches('.product-form__quantity, .product__accordion') ||
    el.querySelector('product-form, .product-form__buttons') !== null;

  const hasContent = (step) => {
    let el = step.nextElementSibling;
    while (el && !el.hasAttribute('data-product-step') && !isEndOfSteps(el)) {
      if (el.getBoundingClientRect().height > 1) return true;
      el = el.nextElementSibling;
    }
    return false;
  };

  const update = () => {
    const steps = [...document.querySelectorAll('[data-product-step]')];
    const visibleSteps = steps.filter(hasContent);
    // A lone "1." reads oddly, so steps only show when there are at least two.
    const showSteps = visibleSteps.length >= 2;
    let number = 0;
    steps.forEach((step) => {
      const visible = showSteps && visibleSteps.includes(step);
      step.classList.toggle('product-step--ready', visible);
      if (!visible) return;
      number += 1;
      step.querySelector('.product-step__number').textContent = number;
      const label = step.querySelector('[data-product-step-label]');
      if (label) label.textContent = `Step ${number}: `;
    });
  };

  const start = () => {
    const container = document.querySelector('[data-product-step]')?.parentElement;
    if (!container) return;
    update();
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    };
    new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
    new ResizeObserver(schedule).observe(container);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
